import * as palette from "@govlaunch/palette";
import { Select } from "@govlaunch/select";
import React from "react";
import { Field } from "react-final-form";
import { FormattedMessage, useIntl } from "react-intl";
import FieldValidationError from "~/components/form/FieldValidationError";
import { Margin } from "~/components/spacings";
import TwoPassRender from "~/components/TwoPassRender";

export function EmployeesNumberField() {
  const intl = useIntl();

  const selectOptions = [
    {
      label: intl.formatMessage({
        defaultMessage: 'Not specified', id: 'Rk7UyM',
      }),
      value: null,
    },
    ...["1 - 10", "11 - 50", "51 - 100", "101 - 500", "500+"].map(value => ({
      label: value,
      value,
    })),
  ];

  return (
    <Field name="numberOfEmployees">
      {({ input, meta }) => (
        <div>
          <div
            css={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <label
              css={{
                fontWeight: 500,
                fontSize: 14,
                color: palette.mediumGray,
                margin: 0,
              }}
            >
              <FormattedMessage defaultMessage="Number of Employees" id="T5WLzg" />
            </label>

            <FieldValidationError meta={meta} />
          </div>

          <Margin mt={8}>
            <TwoPassRender>
              {() => (
                <Select
                  {...input}
                  items={selectOptions}
                  placeholder={intl.formatMessage({
                    defaultMessage: 'Select the number of employees', id: 'J6IRZ1',
                  })}
                />
              )}
            </TwoPassRender>
          </Margin>
        </div>
      )}
    </Field>
  );
}
